/* eslint-disable import/order */
/* eslint-disable import/no-extraneous-dependencies */

import { Container } from '../../layouts/LayoutTable/LayoutTable'
import { GenericTable } from '../GenericTable/GenericTable'
import 'dayjs/locale/pt-br'

import { DivTitle } from '../TitlePage/TitlePage'
import { Pagination } from '../Pagination/Pagination'
import { Loading } from '../Loading/Loading'
import { useTabelaVendas } from './useTabelaVendas'
import { DivColapse, DivInput } from './TabelaVendas.style'

import { dateToBr } from '../../utils/transformDate'

export function TabelaVendas() {
  const { currentPage, setCurrentPage, sales, isLoading, formatarCPF } =
    useTabelaVendas()

  return (
    <div>
      <Container>
        <DivInput>
          <DivColapse>
            <DivTitle color="black" size={22}>
              Vendas
            </DivTitle>
          </DivColapse>
          {isLoading ? (
            <Loading contrast={false} />
          ) : (
            <>
              <GenericTable
                size="270px"
                headers={[
                  'Empresa',
                  'Vendedor',
                  'Cliente',
                  'Data venda',
                  'Produto',
                  'Qtd.',
                ]}
                spacing="20px"
                font="16px"
                vendas
                text
                title5
              >
                {sales.content &&
                  sales.content.map(vendas => (
                    <tr key={vendas.id}>
                      <td className="colVendas7">
                        {vendas.empresa.nome}
                        <br />
                        CNPJ: {formatarCPF(vendas.empresa.cpfcnpj)}
                      </td>
                      <td className="colVendas7">
                        {vendas.vendedor.nome}
                        <br />
                        CPF: {formatarCPF(vendas.vendedor.cpfcnpj)}
                      </td>
                      <td className="colVendas7">
                        {vendas.cliente.nome}
                        <br />
                        CNPJ/CPF: {formatarCPF(vendas.cliente.cpfcnpj)}
                      </td>
                      <td className="colVendas6">
                        {dateToBr(vendas.dataVenda)}
                      </td>
                      <td className="colVendas7">{vendas.produto.nome}</td>
                      <td className="col3">{vendas.quantidade}</td>
                    </tr>
                  ))}
              </GenericTable>
              <Pagination
                pageNumber={currentPage}
                pageSize={sales.totalElements}
                offSet={sales.size}
                onClick={page => setCurrentPage(page)}
              />
            </>
          )}
        </DivInput>
      </Container>
    </div>
  )
}
